<ng-container [formGroup]="sessionPreferenceForm">
  <label class="form-label">{{session.name}}*</label>

  <select class="form-select" formControlName="sessionOptionId" id="sessionOptionId">
    <option selected disabled value="">Select Preference</option>
    <option *ngFor="let option of session.options" [value]="option.id">{{option.name}}</option>
  </select>
</ng-container>
